import bodyScrollClass from './bodyScrollClass.js';
import MainNavigation from './mainNavigation.js';
import NewsListSearch from './NewsListSearch.js';
import WidgetNavigation from './widgetNavigation';
import ResponsiveTable from './ResponsiveTable.js';
import HaanOrderForm from './HaanOrderForm';
import HaanCalculator from './HaanCalculator';
import VideoElement from './VideoElement';
import GoogleMapElement from './GoogleMapElement';
import InfoLayer from './InfoLayer';
import accordion from './accordion';

document.addEventListener('DOMContentLoaded', event => {
  bodyScrollClass();

  new MainNavigation({
    toggleElement: $('.main-navigation__toggle'),
    navigationElement: $('.main-navigation__list')
  });

  $('.news-list').each((index, elm) => {
    new NewsListSearch($(elm));
  });

  $('.widget-navigation').each((index, elm) => {
    new WidgetNavigation($(elm));
  });

  new ResponsiveTable();

  $('.calculator-order').each((index, elm) => {
    new HaanOrderForm($(elm));
  });

  $('.calculator').each((index, elm) => {
    new HaanCalculator($(elm));
  });

  $('.video').each((index, item) => {
    new VideoElement($(item));
  });

  $('.googlemap').each((index, item) => {
    new GoogleMapElement($(item));
  });

  new InfoLayer();

});
